import {
  Button,
  Grid,
  InputLabel,
  makeStyles,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import {
  Container,
  Divider,
  MenuItem,
  TextField as TextAreaa,
} from "@mui/material";
import React, { useState, useContext } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import { path } from "../../../order_managment/constants/apiPath";
import { useEffect } from "react";
import axios from "axios";
import { baseUrlRate, LOCAL_STORAGE_KEY } from "../../../config";
import { getUserData } from "../../common/utility/Utils";
// import { Autocomplete, Stack } from "@mui/material";
import { Stack } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import BackDropRms from "./BackDropRms";
import DailogueRms from "./DailogueRms";
import { useLocation, useNavigate } from "react-router-dom";
import routeConstant from "../../../route/compoent/routeConstant";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { NotificationManager } from "react-notifications";
import WarningModal from "./WarningModal";
import Select from "react-select";
import "./rms.css";
import { StoreContext } from "../../../store/Provider";
import InfoIcon from "@mui/icons-material/Info";

const LCL_Quote = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [warningModalOpen, setWarningModalOpen] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [orgList, setOrgList] = useState([]);
  const [pincodeDestination, setPincodeDestination] = useState("");
  const [sumincm, setSumincm] = useState(0.0);
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [lmdData, setLmdData] = useState({});
  const [rateData, setRateData] = useState("");
  const [freightOptions, setFreightOptions] = useState({
    origin: [],
    destination: [],
    finalDestination: [],
  });
  const rateList = [
    {
      class: 50,
      items: "Fits on standard shrink-wrapped 4X4 pallet, very durable",
    },
    { class: 55, items: "Bricks, cement, mortar, hardwood flooring" },
    { class: 60, items: "Car accessories & car parts" },
    {
      class: 65,
      items: "Car accessories & car parts, bottled beverages, books in boxes",
    },
    {
      class: 70,
      items: "Car accessories & car parts, food items, automobile engines",
    },
    { class: 77.5, items: "Tires, bathroom fixtures" },
    { class: 85, items: "Crated machinery, cast iron stoves" },
    { class: 92.5, items: "Computers, monitors, refrigerators" },
    {
      class: 100,
      items: "boat covers, car covers, canvas, wine cases, caskets",
    },
    { class: 110, items: "cabinets, framed artwork, table saw" },
    { class: 125, items: "Small Household appliances" },
    { class: 150, items: "Auto sheet metal parts, bookcases" },
    { class: 175, items: "Clothing, couches stuffed furniture" },
    {
      class: 200,
      items:
        "Auto sheet metal parts, aircraft parts, aluminum table, packaged mattresses",
    },
    {
      class: 250,
      items: "Bamboo furniture, mattress and box spring, plasma TV",
    },
    { class: 300, items: "wood cabinets, tables, chairs setup, model boats" },
    { class: 400, items: "Deer antlers" },
    { class: 500, items: "Bags of gold dust, ping pong balls" },
  ];

  const [freightValue, setFreightValue] = useState({
    userType: "",
    origin: {},
    destination: {},
    cbm: "",
    finalDestination: "",
    isLastMileSelected: null,
    isInsuraceOpted: null,
    isCustomClearaceOpted: null,
    isHazardous: null,
    pieceCount: null,
    weight: null,
    dimensionHeight: "",
    dimensionLength: "",
    dimensionWidth: "",
    commodity: "",
    lmdDestinationAddress: "",
    finalDestinationPincode: "",
    companyCode: "",
    saleCompanyCode: "",
    rateList: "",
    status: "LCL",
  });
  // console.log("FreightValue", freightValue);
  const { lmdResponse, setLmdResponse } = useContext(StoreContext);

  console.log("LMD RESPONSE: ", lmdResponse);

  useEffect(() => {
    // let Height = convertFeetToCm(freightValue.dimensionHeight);
    // let Length = convertFeetToCm(freightValue.dimensionLength);
    // let Width = convertFeetToCm(freightValue.dimensionWidth);
    // let piece = freightValue.pieceCount == null ? 1 : freightValue.pieceCount;
    let temp =
      freightValue.dimensionHeight *
      freightValue.dimensionLength *
      freightValue.dimensionWidth *
      freightValue.pieceCount *
      0.0283168466;
    setSumincm(temp);
    setFreightValue({ ...freightValue, cbm: temp });
  }, [
    freightValue.dimensionHeight,
    freightValue.dimensionLength,
    freightValue.dimensionWidth,
    freightValue.pieceCount,
  ]);
  useEffect(() => {
    getFreightOrigin();
  }, []);

  const getFreightOrigin = async () => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const url = `${baseUrlRate}${path.GET_FREIGHT_ORIGIN}`;
    axios
      .get(url, {
        headers: header,
      })
      .then((res) => {
        setFreightOptions({ ...freightOptions, origin: res.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // console.log("freightValue", freightValue);
  const getFreightDestination = async (origin) => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const url = `${baseUrlRate}${path.GET_FREIGHT_DESTINATION}${origin}`;
    axios
      .get(url, {
        headers: header,
      })
      .then((res) => {
        setFreightOptions({
          ...freightOptions,
          destination: res.data?.allDestn ?? [],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getUserRole = async () => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    const url = `${baseUrlRate}${path.GET_USER_ROLE}`;
    axios
      .get(url, {
        headers: header,
      })
      .then((res) => {
        if (res.data.role == "SALES") {
          setFreightValue({ ...freightValue, userType: res.data.role });
          const url = `${baseUrlRate}${path.GET_CUST_BY_SALE_AGENT}`;
          axios
            .get(url, {
              headers: header,
            })
            .then((res) => {
              setOrgList(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          setFreightValue({
            ...freightValue,
            companyCode: res.data.companyCode,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getUserRole();
  }, []);
  const originOptions = freightOptions.origin.map((origin) => {
    return {
      value: origin.originCode,
      label: origin.origin,
      originCode: origin.originCode,
      origin: origin.origin,
    };
  });

  const destinationOptionsfun = () => {
    let tempOptions = freightOptions.destination.map((destination) => {
      return {
        value: destination,
        label: destination.destination,
        // originCode: origin.originCode,
        // origin: origin.origin,
      };
    });
    setDestinationOptions(tempOptions);
    // destinationOptions = tempOptions;
  };
  const orgListOptions = orgList?.map((org) => {
    return {
      value: org,
      label: org.fullName,
      // originCode: origin.originCode,
      // origin: origin.origin,
    };
  });
  const rateListOptions = rateList.map((item) => (
    <Tooltip title={item.items}>
      <option>{item.class}</option>
    </Tooltip>
  ));

  const rateDescription = rateList.find((indvRate) => {
    return parseInt(indvRate.class) === parseInt(rateData);
  });

  // console.log("Description: ", rateDescription);
  // console.log("RateList: ", rateData);

  useEffect(() => {
    destinationOptionsfun();
  }, [freightOptions.destination]);

  const getLMDRates = async () => {
    // console.log("Get LMD rates button clicked.");
    const body = {
      originPostalCode: freightValue.destination.destinationZipCode,
      destinationPostalCode: freightValue.finalDestination,
      ratedClass: `${freightValue.rateList}`,
      weight: `${freightValue.weight}`,
    };
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
      // originPostalCode: "78744",
      // destinationPostalCode: "44130",
      // ratedClass: "60",
      // weight: "140",
    };
    const url = `${baseUrlRate}${path.GET_LMD_RATE}`;
    axios
      .post(url, body, {
        headers: header,
      })
      .then((res) => {
        setLmdResponse(res?.data);
        // console.log("Response: ", lmdData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  console.log("Length: ", freightValue?.commodity?.length);

  useEffect(() => {
    if (
      // freightValue.destination.destinationZipCode !== "" &&
      freightValue?.destination?.destinationZipCode?.length === 5 &&
      freightValue?.finalDestination !== "" &&
      freightValue?.finalDestination?.length === 5 &&
      freightValue.rateList !== "" &&
      freightValue.weight !== null
    ) {
      getLMDRates();
    }
  }, [
    freightValue.destination.destinationZipCode,
    freightValue.finalDestination,
    freightValue.rateList,
    freightValue.weight,
  ]);

  return (
    <>
      <div className="flex-direction-row quotesmain">
        {backdropOpen ? (
          <BackDropRms
            backdropOpen={backdropOpen}
            setBackdropOpen={setBackdropOpen}
          />
        ) : null}
        {warningModalOpen ? (
          <WarningModal
            dailogueOpen={warningModalOpen}
            setDailogueOpen={setWarningModalOpen}
            freightValue={freightValue}
          />
        ) : null}

        {/* <Paper
            elevation={2}
            style={{
              padding: "1%",
              marginBottom: "1%",
            }}
          >
            <Typography style={{ fontWeight: 700 }}>
              Select Origin Destination pair
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Autocomplete
                  fullWidth
                  disablePortal
                  id="combo-box-demo"
                  options={freightOptions.origin}
                  renderInput={(params) => (
                    <TextField
                      required
                      value={freightValue.origin.originCode}
                      {...params}
                      label="Origin"
                    />
                  )}
                  onChange={(event, newValue) => {
                    setFreightValue({
                      ...freightValue,
                      origin: newValue ?? {},
                    });
                    getFreightDestination(newValue?.originCode ?? "");
                  }}
                  getOptionLabel={(option) => option.origin}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  fullWidth
                  disablePortal
                  id="combo-box-demo"
                  options={freightOptions.destination}
                  renderInput={(params) => (
                    <TextField
                      required
                      value={freightValue.destination?.destinationCode}
                      {...params}
                      label="Destination"
                    />
                  )}
                  onChange={(event, newValue) => {
                    setPincodeDestination(newValue.destinationZipCode ?? "");
                    setFreightValue({
                      ...freightValue,
                      destination: newValue ?? {},
                    });
                  }}
                  getOptionLabel={(option) => option.destination}
                />
              </Grid>
              <Grid
                item
                xs={4}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <FormControl required>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Include Last Mile Delivery
                  </FormLabel>
                  <RadioGroup
                    style={{
                      justifyContent: "flex-end",
                    }}
                    row
                    value={freightValue.isLastMileSelected}
                    onChange={(e) => {
                      setFreightValue({
                        ...freightValue,
                        isLastMileSelected: e.target.value,
                      });
                    }}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value={"true"}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={"false"}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  required
                  value={freightValue?.commodity}
                  id="standard-basic"
                  label="Commodity"
                  variant="standard"
                  onChange={(e) => {
                    setFreightValue({
                      ...freightValue,
                      commodity: e.target.value,
                    });
                  }}
                />
              </Grid>
              {freightValue.userType && (
                <Grid item xs={4}>
                  <Autocomplete
                    fullWidth
                    disablePortal
                    id="combo-box-demo"
                    options={orgList}
                    renderInput={(params) => (
                      <TextField
                        required
                        value={freightValue.saleCompanyCode.fullName}
                        {...params}
                        label="Org List"
                      />
                    )}
                    onChange={(event, newValue) => {
                      console.log(event, newValue);
                      setFreightValue({
                        ...freightValue,
                        saleCompanyCode: newValue ?? {},
                      });
                      // getFreightDestination(newValue?.originCode ?? "");
                    }}
                    getOptionLabel={(option) => option.fullName}
                  />
                </Grid>
              )}
  
              {freightValue.isLastMileSelected === "true" ? (
                <>
                  <Grid
                    item
                    xs={8}
                    style={{
                      paddingTop: "2%",
                    }}
                  >
                    <TextAreaa
                      height={100}
                      fullWidth
                      value={freightValue?.lmdDestinationAddress}
                      id="standard-basic"
                      label="Address"
                      rows={4}
                      multiline
                      variant="outlined"
                      onChange={(e) => {
                        setFreightValue({
                          ...freightValue,
                          lmdDestinationAddress: e.target.value,
                        });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Grid
                      container
                      spacing={3}
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        flexDirection: "row",
                        alignItems: "flex-end",
                      }}
                    >
                      <Grid item xs={12}>
                        <TextField
                          required
                          fullWidth
                          disabled
                          value={pincodeDestination}
                          id="standard-basic"
                          label="Destination Pin Code"
                          variant="standard"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          value={freightValue?.finalDestination}
                          id="standard-basic"
                          label="Final Destination ZIP Code"
                          variant="standard"
                          onChange={(e) => {
                            setFreightValue({
                              ...freightValue,
                              finalDestination: e.target.value,
                            });
                          }}
                        />{" "}
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ) : null}
            </Grid>
          </Paper> */}
        <Container
          maxWidth="xl"
          sx={{
            padding: "5px",
          }}
        >
          {freightValue.userType && (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                Please select the organization you wish to act for :
              </Grid>
              <Grid item xs={3}>
                <Select
                  required
                  className="reactSelect"
                  placeholder={
                    <Typography variant="caption">Organzation</Typography>
                  }
                  options={orgListOptions}
                  value={origin.origin}
                  // onChange={(selectedOption) => {
                  //   console.log("selectedOption", selectedOption);
                  //   setFreightValue({
                  //     ...freightValue,
                  //     origin: selectedOption ?? {},
                  //   });
                  //   getFreightDestination(selectedOption?.originCode ?? "");
                  // }}
                  onChange={(selectedOption) => {
                    setFreightValue({
                      ...freightValue,
                      saleCompanyCode: selectedOption.value ?? {},
                    });
                    // getFreightDestination(newValue?.originCode ?? "");
                  }}
                />
                {/* <Autocomplete
                    fullWidth
                    disablePortal
                    id="combo-box-demo"
                    options={orgList}
                    renderInput={(params) => (
                      <TextField
                        required
                        value={freightValue.saleCompanyCode.fullName}
                        {...params}
                        label="Org List"
                      />
                    )}
                    onChange={(event, newValue) => {
                      console.log(event, newValue);
                      setFreightValue({
                        ...freightValue,
                        saleCompanyCode: newValue ?? {},
                      });
                      // getFreightDestination(newValue?.originCode ?? "");
                    }}
                    getOptionLabel={(option) => option.fullName}
                  /> */}
              </Grid>
            </Grid>
          )}
          {/* {freightValue.userType &&
            freightValue?.saleCompanyCode.lenght >= 0 ? (
              <h1>hello</h1>
            ) : (
              <h2>hii</h2>
            )} */}
          <Grid container spacing={4}>
            <Grid
              item
              xs={6}
              style={{
                backgroundColor: "#fff",
              }}
            >
              <Typography variant="overline" color="primary">
                Select Origin Destination pair
              </Typography>
              <Divider
                style={{
                  width: "83%",
                }}
              />
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                backgroundColor: "#fff",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="overline" color="primary">
                  Dimensions
                </Typography>
                {/* <Typography
                    variant="overline"
                    color="primary"
                  >{`${sumincm.toFixed(3)} CBM`}</Typography> */}
              </div>
              <Divider
                style={{
                  width: "89%",
                }}
              />
            </Grid>
            {/* LEFT COLUMN */}
            <Grid
              item
              xs={6}
              style={{
                backgroundColor: "#fff",
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <Select
                    required
                    className="reactSelect"
                    placeholder={
                      <Typography variant="caption">Origin *</Typography>
                    }
                    options={originOptions}
                    value={origin.origin}
                    onChange={(selectedOption) => {
                      setFreightValue({
                        ...freightValue,
                        origin: selectedOption ?? {},
                      });
                      getFreightDestination(selectedOption?.originCode ?? "");
                    }}
                  />
                  {/* <Autocomplete
                  fullWidth
                  disablePortal
                  id="fixed-tags-demo"
                  options={freightOptions.origin}
                  getOptionLabel={(option) => option.origin}
                  renderInput={(params) => (
                    <TextField
                      required
                      variant="outlined"
                      value={freightValue.origin.originCode}
                      {...params}
                      label={<Typography variant="overline">Origin</Typography>}
                    />
                  )}
                  onChange={(event, newValue) => {
                    setFreightValue({
                      ...freightValue,
                      origin: newValue ?? {},
                    });
                    getFreightDestination(newValue?.originCode ?? "");
                  }}
                /> */}
                </Grid>
                <Grid item xs={5}>
                  <Select
                    required
                    className="reactSelect"
                    placeholder={
                      <Typography variant="caption">Destination *</Typography>
                    }
                    options={destinationOptions}
                    // value={origin.origin}
                    onChange={(selectedOption) => {
                      setPincodeDestination(
                        selectedOption?.value?.destinationZipCode ?? ""
                      );
                      setFreightValue({
                        ...freightValue,
                        destination: selectedOption.value ?? {},
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    fullWidth
                    required
                    value={freightValue?.commodity}
                    id="standard-basic"
                    label={<Typography variant="caption">Commodity</Typography>}
                    variant="standard"
                    onChange={(e) => {
                      const alphabetRegex = /^[a-zA-Z ]+$/;
                      if (
                        alphabetRegex.test(e.target.value) ||
                        e.target.value?.length === 0
                      ) {
                        setFreightValue({
                          ...freightValue,
                          commodity: e.target.value,
                        });
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    fullWidth
                    required
                    type="Number"
                    value={freightValue?.pieceCount}
                    id="standard-basic"
                    label={
                      <Typography variant="caption">Piece Count</Typography>
                    }
                    variant="standard"
                    onChange={(e) => {
                      setFreightValue({
                        ...freightValue,
                        pieceCount: e.target.value,
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={5}
                  style={{
                    marginTop: "2rem",
                  }}
                >
                  <TextField
                    fullWidth
                    required
                    type="Number"
                    value={freightValue?.weight}
                    id="standard-basic"
                    label={
                      <Typography variant="caption">Weight (in Ton)</Typography>
                    }
                    variant="standard"
                    onChange={(e) => {
                      setFreightValue({
                        ...freightValue,
                        weight: e.target.value,
                        finalDestination: "",
                        lmdDestinationAddress: "",
                        isLastMileSelected: "",
                      });
                    }}
                  />
                </Grid>
                {parseInt(freightValue.weight) * 2204.62262185 <= 50000 ? (
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "row",
                      paddingTop: "2rem",
                    }}
                  >
                    <FormControl
                      required
                      style={{
                        width: "100%",
                        flexDirection: "row",
                        display: "flex",
                        justifyContent: "start",
                      }}
                    >
                      <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        sx={{
                          paddingTop: "1rem",
                          marginRight: "1rem",
                        }}
                      >
                        <Typography variant="overline">
                          {" "}
                          Include Last Mile Delivery{" "}
                        </Typography>
                      </FormLabel>
                      <RadioGroup
                        style={{
                          justifyContent: "flex-end",
                        }}
                        row
                        value={freightValue.isLastMileSelected}
                        onChange={(e) => {
                          setFreightValue({
                            ...freightValue,
                            isLastMileSelected: e.target.value,
                            finalDestination: "",
                            lmdDestinationAddress: "",
                          });
                        }}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                      >
                        <FormControlLabel
                          value={"true"}
                          control={<Radio color="primary" />}
                          label={
                            <span style={{ fontSize: "0.8rem" }}>Yes</span>
                          }
                        />
                        <FormControlLabel
                          value={"false"}
                          control={<Radio color="primary" />}
                          label={<span style={{ fontSize: "0.8rem" }}>No</span>}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                ) : parseInt(freightValue.weight) * 2204.62262185 > 50000 ? (
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.54)",
                      fontSize: "0.75rem",
                      paddingTop: "40px",
                      paddingLeft: "5px",
                      width: "60%",
                    }}
                  >
                    Last Mile Delivery is offered only for cargo weighing upto
                    50000 Pounds or 22.67 tonnes.
                  </Typography>
                ) : (
                  ""
                )}

                {parseInt(freightValue.weight) * 2204.62262185 <= 50000 &&
                freightValue.isLastMileSelected === "true" ? (
                  <>
                    <Grid item xs={5}>
                      {/* <Select
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              borderColor: state.isFocused ? "grey" : "red",
                            }),
                          }}
                          required
                          className="reactSelect"
                          placeholder={
                            <Typography variant="caption">Rate List *</Typography>
                          }
                          options={rateListOptions}
                          // value={origin.origin}
                          onChange={(selectedOption) => {
                            setFreightValue({
                              ...freightValue,
                              rateList: selectedOption.value ?? "",
                            });
                          }}
                        /> */}
                      <select
                        style={{
                          width: "300px",
                          color: "rgba(0, 0, 0, 0.54)",
                          borderTop: "none",
                          borderLeft: "none",
                          borderRight: "none",
                          fontSize: "0.75rem",
                          borderColor: "rgba(0, 0, 0, 0.54)",
                        }}
                        required
                        onChange={(selectedOption) => {
                          setRateData(selectedOption.target.value);
                          console.log(selectedOption.target.value);
                          setFreightValue({
                            ...freightValue,
                            rateList: selectedOption.target.value ?? "",
                          });
                        }}
                      >
                        <option disabled selected>
                          Rate List*
                        </option>

                        {rateListOptions}
                      </select>
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      style={{
                        fontSize: "16px",
                        display: "flex",
                        paddingTop: "20px",
                        alignItems: "start",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        style={{
                          // color: "rgba(0, 0, 0, 0.54)",
                          fontWeight: "500",
                        }}
                      >
                        {/* {rateDescription?.items ?? ""} */}
                      </div>
                      {/* <button
                          onClick={() => getLMDRates()}
                          style={{
                            border: "1px solid #3f51b5",
                            borderRadius: "5px",
                            backgroundColor: "white",
                            height: "30px",
                          }}
                        >
                          Get LMD rate
                        </button> */}
                    </Grid>
                    <Grid
                      item
                      xs={10}
                      style={{
                        paddingTop: "2%",
                      }}
                    >
                      <TextAreaa
                        height={100}
                        fullWidth
                        value={freightValue?.lmdDestinationAddress}
                        id="standard-basic"
                        label={
                          <Typography variant="caption">Address</Typography>
                        }
                        rows={4}
                        multiline
                        variant="outlined"
                        onChange={(e) => {
                          setFreightValue({
                            ...freightValue,
                            lmdDestinationAddress: e.target.value,
                          });
                        }}
                      />
                    </Grid>

                    <Grid item xs={5}>
                      <TextField
                        required
                        fullWidth
                        disabled
                        value={pincodeDestination}
                        id="standard-basic"
                        label={
                          <Typography variant="caption">
                            From ZIP Code{" "}
                          </Typography>
                        }
                        variant="standard"
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        required
                        fullWidth
                        value={freightValue?.finalDestination}
                        type="Number"
                        id="standard-basic"
                        // label="To ZIP Code"
                        label={
                          <Typography variant="caption">To ZIP Code</Typography>
                        }
                        variant="standard"
                        onChange={(e) => {
                          if (e.target.value.length <= 5) {
                            setFreightValue({
                              ...freightValue,
                              finalDestination: e.target.value,
                            });
                          }
                        }}
                      />{" "}
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </Grid>

            {/* RIGHT COLUMN */}
            <Grid
              item
              xs={6}
              style={{
                backgroundColor: "#fff",
              }}
            >
              <Grid container spacing={2}>
                {/* LEFT IN RIGHT */}
                <Grid item xs={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={10}>
                      <TextField
                        fullWidth
                        required
                        type="Number"
                        value={freightValue?.dimensionLength}
                        id="standard-basic"
                        label={
                          <Typography variant="caption">
                            Length (in feet)
                          </Typography>
                        }
                        variant="standard"
                        onChange={(e) => {
                          setFreightValue({
                            ...freightValue,
                            dimensionLength: e.target.value,
                          });
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={10}
                      style={{
                        marginTop: "2rem",
                      }}
                    >
                      <TextField
                        fullWidth
                        required
                        type="Number"
                        value={freightValue?.dimensionWidth}
                        id="standard-basic"
                        label={
                          <Typography variant="caption">
                            Width (in feet)
                          </Typography>
                        }
                        variant="standard"
                        onChange={(e) => {
                          setFreightValue({
                            ...freightValue,
                            dimensionWidth: e.target.value,
                          });
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={10}
                      style={{
                        marginTop: "2rem",
                      }}
                    >
                      {" "}
                      <TextField
                        fullWidth
                        required
                        type="Number"
                        value={freightValue?.dimensionHeight}
                        id="standard-basic"
                        label={
                          <Typography variant="caption">
                            Height (in feet){" "}
                          </Typography>
                        }
                        variant="standard"
                        onChange={(e) => {
                          setFreightValue({
                            ...freightValue,
                            dimensionHeight: e.target.value,
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* RIGHT IN RIGHT */}
                <Grid item xs={6} style={{}}>
                  <Grid
                    container
                    spacing={2}
                    style={{
                      display: "flex",
                      height: "100%",
                      // backgroundColor: "green",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        border: "1px solid blue",
                        paddingRight: "3%",
                        borderRadius: "5px",
                      }}
                    >
                      <Button disabled color="primary" size="large">
                        <Typography
                          variant="h5"
                          color="primary"
                          style={{
                            maxWidth: "250px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >{` ${sumincm.toFixed(3)}`}</Typography>
                      </Button>
                      <Typography
                        variant="overline"
                        color="primary"
                      >{` CBM`}</Typography>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  marginTop: "2rem",
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  // paddingTop: "2rem",
                }}
              >
                <FormControl
                  required
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    sx={{
                      marginRight: "1rem",
                    }}
                  >
                    <Typography variant="overline">
                      Include Insurance
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    style={{
                      justifyContent: "flex-end",
                    }}
                    row
                    value={freightValue.isInsuraceOpted}
                    onChange={(e) => {
                      setFreightValue({
                        ...freightValue,
                        isInsuraceOpted: e.target.value,
                      });
                    }}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      size="small"
                      value={"true"}
                      control={
                        <Radio
                          size="small"
                          color="primary"
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 28,
                            },
                          }}
                        />
                      }
                      label={<span style={{ fontSize: "0.8rem" }}>Yes</span>}
                    />
                    <FormControlLabel
                      value={"false"}
                      control={<Radio color="primary" />}
                      label={<span style={{ fontSize: "0.8rem" }}>No</span>}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  marginTop: "2rem",
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  // paddingTop: "2rem",
                }}
              >
                <FormControl
                  required
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    sx={{
                      marginRight: "1rem",
                    }}
                  >
                    <Typography variant="overline">
                      Include Custom Clearance
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    value={freightValue.isCustomClearaceOpted}
                    onChange={(e) => {
                      setFreightValue({
                        ...freightValue,
                        isCustomClearaceOpted: e.target.value,
                      });
                    }}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value={"true"}
                      control={<Radio color="primary" />}
                      label={<span style={{ fontSize: "0.8rem" }}>Yes</span>}
                    />
                    <FormControlLabel
                      value={"false"}
                      control={<Radio color="primary" />}
                      label={<span style={{ fontSize: "0.8rem" }}>No</span>}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  marginTop: "2rem",
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  // paddingTop: "2rem",
                }}
              >
                <FormControl
                  required
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "start",
                  }}
                >
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    sx={{
                      marginRight: "1rem",
                    }}
                  >
                    <Typography variant="overline"> Is Hazardous</Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    value={freightValue.isHazardous}
                    onChange={(e) => {
                      setFreightValue({
                        ...freightValue,
                        isHazardous: e.target.value,
                      });
                    }}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value={"true"}
                      control={<Radio color="primary" />}
                      label={<span style={{ fontSize: "0.8rem" }}>Yes</span>}
                    />
                    <FormControlLabel
                      value={"false"}
                      control={<Radio color="primary" />}
                      label={<span style={{ fontSize: "0.8rem" }}>No</span>}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Typography
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "red",
                  padding: "0.3rem 0",
                  textAlign: "center",
                  fontSize: "18px",
                }}
              >
                {/* This Quotation is subject to in and out warehouse charges */}
                <span>
                  {" "}
                  Rates are valid 2 weeks from the date of quote creation. Rates
                  are included the warehouse in and out charges. Also for CBM
                  greater than 25, LCL rates are not available. FCL is
                  recommended.
                  <span
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() => navigate(routeConstant.FCL_CREATE_QUOTE)}
                  >
                    {" "}
                    Click here{" "}
                  </span>
                  to create FCL Quotes.
                </span>
              </Typography>
            </Grid>
            <Button
              // color="primary"
              disabled={JSON.parse(sumincm > 25)}
              style={
                JSON.parse(sumincm > 25)
                  ? { backgroundColor: "#6c757d", color: "#ffff" }
                  : { backgroundColor: "#0d6efd", color: "#ffff" }
              }
              variant="contained"
              fullWidth
              onClick={() => {
                if (
                  freightValue.origin &&
                  freightValue.destination &&
                  freightValue.commodity &&
                  freightValue.pieceCount &&
                  freightValue.weight &&
                  freightValue.dimensionLength &&
                  freightValue.dimensionWidth &&
                  freightValue.dimensionHeight &&
                  freightValue.isHazardous &&
                  freightValue.isCustomClearaceOpted &&
                  // freightValue.isLastMileSelected &&
                  freightValue.isInsuraceOpted &&
                  (freightValue.userType == "SALES"
                    ? freightValue.saleCompanyCode
                    : true)
                ) {
                  if (
                    parseInt(freightValue.weight) * 2204.62262185 <= 50000 &&
                    freightValue.isLastMileSelected === "true" &&
                    freightValue.lmdDestinationAddress === "" &&
                    freightValue.finalDestinationPincode === ""
                  ) {
                    NotificationManager.error(
                      "Attention! All fields are mandatory",
                      "",
                      3000
                    );
                  } else {
                    setWarningModalOpen(true);
                  }
                } else {
                  NotificationManager.error(
                    "Attention! All fields are mandatory",
                    "",
                    3000
                  );
                }
              }}
            >
              Get Rate
            </Button>
          </Grid>
        </Container>
        {/* <Paper
            elevation={3}
            style={{
              padding: "1%",
              marginBottom: "1%",
            }}
          ></Paper> */}
        {/* UNITS */}

        {/* DIMENSIONS */}

        {/* ADDITIONAL SERVICE */}
        {/* <Paper
            elevation={3}
            style={{
              padding: "1%",
              marginBottom: "1%",
            }}
          >
            <Typography style={{ fontWeight: 700 }} gutterBottom>
              Additional Services
            </Typography>
            <Grid container>
              <Grid item xs={12}></Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </Paper> */}

        {/* <Paper elevation={3}>
            <Typography
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "red",
                padding: "0.3rem 0",
              }}
            >
              This Quotation is subject to in and out warehouse charges
            </Typography>
          </Paper> */}

        <Stack
          direction="row"
          spacing={3}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
            padding: "0.3rem 0",
          }}
        ></Stack>
      </div>
    </>
  );
};

export default LCL_Quote;

const useStyles = makeStyles((theme) => ({
  container: {
    "@media (max-width: 780px)": {
      borderRight: "none",
    },
    display: "inline-flex",
    height: "100%",
  },
  MuiInputLabel: {
    top: "-1rem",
  },
}));
